import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { GlobalSearch } from './GlobalSearch'
import { Container } from '@mantine/core'

interface LayoutProps {
  children?: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <GlobalSearch />
      <div style={{ display: 'flex', height: '100vh' }}>
        {/* Sidebar */}
        <Sidebar />

        {/* Main content */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Header />
          <main
            style={{ flex: 1, overflowY: 'auto', backgroundColor: '#f8fafc' }}
          >
            <Container size="xl" p="xl">
              {children || <Outlet />}
            </Container>
          </main>
        </div>
      </div>
    </div>
  )
}
